export default api => ({
  getCitizens: async params => await api.get('/places/citizen', { params }),
  getCountries: async params => await api.get('/places/countries', { params })
});
